const FALLBACK_SERVER_URL = "https://rentdigicare.ca/api";
const FALLBACK_CHAT_URL = "wss://rentdigicare.ca/api";

const DEV_SERVER_URL = (process.env.REACT_APP_SERVER_URL || FALLBACK_SERVER_URL).replace(/\/+$/, "");
const DEV_CHAT_URL = process.env.REACT_APP_CHAT_URL || FALLBACK_CHAT_URL;

const PROD_SERVER_URL = (process.env.REACT_APP_PROD_SERVER_URL || "https://rentdigicare.ca/api").replace(/\/+$/, "");
const PROD_CHAT_URL = process.env.REACT_APP_PROD_CHAT_URL || "wss://rentdigicare.ca/api";

export const IS_PRODUCTION_BUILD = process.env.NODE_ENV === "production";

const OVERRIDE_KEY = "__rdc_api_override__";

let override = null;
if (!IS_PRODUCTION_BUILD && typeof window !== "undefined") {
  try { override = window.localStorage.getItem(OVERRIDE_KEY); } catch (_) {}
}

const useProd = override === "prod";

export const SERVER_URL = useProd ? PROD_SERVER_URL : DEV_SERVER_URL;
export const CHAT_URL = useProd ? PROD_CHAT_URL : DEV_CHAT_URL;
export const IS_LIVE_API = /rentdigicare\.(com|ca)/i.test(SERVER_URL);

if (typeof window !== "undefined" && !window.__rdc_api_banner_shown__) {
  window.__rdc_api_banner_shown__ = true;
  const mode = IS_PRODUCTION_BUILD ? "PRODUCTION BUILD" : "DEV";
  const tag = IS_LIVE_API ? "LIVE API" : "LOCAL API";
  const suffix = !IS_PRODUCTION_BUILD && useProd ? " (overridden → PROD)" : "";
  const style = IS_LIVE_API
    ? "background:#b91c1c;color:#fff;padding:2px 8px;border-radius:3px;font-weight:bold"
    : "background:#16a34a;color:#fff;padding:2px 8px;border-radius:3px;font-weight:bold";
  console.info(`%c[${mode}] ${tag}${suffix}%c  →  ${SERVER_URL}`, style, "color:inherit");
}

if (!IS_PRODUCTION_BUILD && typeof window !== "undefined") {
  window.rdcApi = (target) => {
    const next = target === "toggle" ? (useProd ? "dev" : "prod") : target;
    if (next !== "prod" && next !== "dev") {
      console.warn("[rdcApi] usage: rdcApi('prod' | 'dev' | 'toggle')");
      return;
    }
    try {
      if (next === "prod") window.localStorage.setItem(OVERRIDE_KEY, "prod");
      else window.localStorage.removeItem(OVERRIDE_KEY);
    } catch (_) {}
    window.location.reload();
  };

  if (!window.__rdc_api_pill__) {
    window.__rdc_api_pill__ = true;
    const mount = () => {
      if (document.getElementById("__rdc_api_pill_el__")) return;
      const pill = document.createElement("button");
      pill.id = "__rdc_api_pill_el__";
      pill.type = "button";
      pill.textContent = useProd ? "API: PROD ⇄ DEV" : "API: DEV ⇄ PROD";
      pill.title = `Currently talking to: ${SERVER_URL}\nClick to switch to ${useProd ? "DEV" : "PROD"} (page will reload)`;
      Object.assign(pill.style, {
        position: "fixed",
        bottom: "12px",
        right: "12px",
        zIndex: "2147483647",
        padding: "6px 12px",
        fontFamily: "system-ui, -apple-system, sans-serif",
        fontSize: "11px",
        fontWeight: "700",
        letterSpacing: "0.3px",
        color: "#fff",
        background: useProd ? "#b91c1c" : "#16a34a",
        border: "none",
        borderRadius: "999px",
        cursor: "pointer",
        boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
        opacity: "0.85",
      });
      pill.addEventListener("mouseenter", () => { pill.style.opacity = "1"; });
      pill.addEventListener("mouseleave", () => { pill.style.opacity = "0.85"; });
      pill.addEventListener("click", () => window.rdcApi("toggle"));
      document.body.appendChild(pill);
    };
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", mount, { once: true });
    } else {
      mount();
    }
  }
}
